import Groups3Icon from "@mui/icons-material/Groups3";
import HttpsOutlinedIcon from "@mui/icons-material/HttpsOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import TabPanelCmp from "../../../components/tabPanel/tabPanelCmp";
import { GetUserMenusByUserIdResponse } from "../../../models/menu.model";
import {
  GetOfficePostsByUserIdResponse,
  GetUserOfficePostsResponse,
} from "../../../models/officePosts.model";
import {
  GetRolesNotExistInUserRolesResponse,
  GetUserRolesResponse,
} from "../../../models/role.model";
import {
  AddUserPermissionResponse,
  GetAPIPermissionsResponse,
} from "../../../models/userPermission.model";
import { GetUserReportsResponse } from "../../../models/userReport.model";
import { GetUserMenusByUserId } from "../../../services/menu.service";
import {
  GetOfficePostsByUserId,
  GetUserOfficePosts,
} from "../../../services/officePosts.service";
import {
  GetRolesNotExistInUserRoles,
  GetUserRoles,
} from "../../../services/role.service";
import {
  GetAPIPermissions,
  GetUserPermissions,
} from "../../../services/userPermissions.service";
import { GetUserReports } from "../../../services/userReport.service";
import Certificate from "./Certificate";
import ChangePassword from "./ChangePassword";
import Menus from "./Menus";
import Posts from "./posts";
import Reports from "./Reports";
import Roles from "./Roles";
import TabsSkeleton from "./TabsSkeleton";

interface Props {
  userId: number;
}

const PermissionsTabs = ({ userId }: Props) => {
  const [userOfficePosts, setUserOfficePosts] = useState<
    GetUserOfficePostsResponse[]
  >([]);
  const [userOfficeRoles, setUserOfficeRoles] = useState<
    GetUserRolesResponse[]
  >([]);
  const [userMenus, setUserMenus] = useState<GetUserMenusByUserIdResponse[]>(
    []
  );

  const [userRoleOptions, setUserRoleOptions] = React.useState<
    GetRolesNotExistInUserRolesResponse[]
  >([]);
  const [userPermissionOptions, setUserPermissionOptions] = React.useState<
    GetAPIPermissionsResponse[]
  >([]);
  const [treeData, setTreeData] = useState([
    {
      title: "چارت سازمانی",
      children: [],
      id: 0,
      parentOfficePostId: 0,
    },
  ]);
  const [userPermissionsList, setUserPermissionsList] = useState<
    AddUserPermissionResponse[]
  >([]);
  const [userReportList, setUserReportList] = useState<
    GetUserReportsResponse[]
  >();
  const [updateGetUserOfficePosts, setUpdateGetUserOfficePosts] = useState("");
  const [updateGetUserOfficeRoles, setUpdateGetUserOfficeRoles] = useState("");
  const [updateGetUserPermissions, setUpdateGetUserPermissions] = useState("");
  const [updateGetApiPermissions, setUpdateGetApiPermissions] = useState("");
  const [
    updateGetUserOfficePostById,
    setUpdateGetUserOfficePostById,
  ] = useState("");

  const { mutate: GetUserOfficePostsMutate, isLoading } = useMutation(
    GetUserOfficePosts,
    {
      onSuccess: (data: GetUserOfficePostsResponse[]) => {
        if (data) {
          setUserOfficePosts(data);
        }
      },
      onError: () => {},
    }
  );

  const { mutate: GetUserRolesMutate } = useMutation(GetUserRoles, {
    onSuccess: (data: GetUserRolesResponse[]) => {
      if (data) {
        setUserOfficeRoles(data);
      }
    },
    onError: () => {},
  });
  function getNestedChildrenPost(arr: any, parent: any) {
    var children = [];
    for (var i = 0; i < arr.length; ++i) {
      if (arr[i].parentOfficePostId === parent.parentOfficePostId) {
        var grandChildren = getNestedChildrenPost(
          arr[i].subOfficePostResponses,
          {
            parentOfficePostId: arr[i].id,
          }
        );

        if (grandChildren.length) {
          arr[i].children = grandChildren;
        }
        arr[i].expanded = true;
        children.push(arr[i]);
      }
    }
    return children;
  }
  function getNestedChildren(arr: any, parent: any) {
    var children = [];
    for (var i = 0; i < arr?.length; ++i) {
      if (arr[i].parentMenuId === parent.parentMenuId) {
        var grandChildren = getNestedChildren(arr[i].subMenuResponses, {
          parentMenuId: arr[i].id,
        });

        if (grandChildren.length) {
          arr[i].children = grandChildren;
        }
        arr[i].expanded = true;
        children.push(arr[i]);
      }
    }
    return children;
  }
  const { mutate: GetUserMenusByUserIdMutate } = useMutation(
    GetUserMenusByUserId,
    {
      onSuccess: (data: GetUserMenusByUserIdResponse[]) => {
        if (data) {
          var nest = getNestedChildren(data, { parentMenuId: null });
          setUserMenus(nest);
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetRolesNotExistInUserRolesMutate } = useMutation(
    GetRolesNotExistInUserRoles,
    {
      onSuccess: (data: GetRolesNotExistInUserRolesResponse[]) => {
        if (data) {
          setUserRoleOptions(data);
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetOfficePostsByUserIdMutate } = useMutation(
    GetOfficePostsByUserId,
    {
      onSuccess: (data: GetOfficePostsByUserIdResponse[]) => {
        if (data) {
          var nest = getNestedChildrenPost(data, { parentOfficePostId: null });
          setTreeData(nest);
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetUserPermissionsMutate } = useMutation(GetUserPermissions, {
    onSuccess: (data: AddUserPermissionResponse[]) => {
      if (data) {
        setUserPermissionsList(data);
      }
    },
    onError: () => {},
  });
  const { mutate: GetAPIPermissionsMutate } = useMutation(GetAPIPermissions, {
    onSuccess: (data: GetAPIPermissionsResponse[]) => {
      if (data) {
        setUserPermissionOptions(data);
      }
    },
    onError: () => {},
  });

  const { mutate: GetUserReportsMutate } = useMutation(GetUserReports, {
    onSuccess: (data: GetUserReportsResponse[]) => {
      if (data) {
        setUserReportList(data);
      }
    },
    onError: () => {},
  });

  useEffect(() => {
    GetUserReportsMutate({
      userId: userId,
    });
    GetUserMenusByUserIdMutate({
      id: userId,
    });
  }, []);

  useEffect(() => {
    GetAPIPermissionsMutate({
      title: "",
      userId: userId,
    });
  }, [updateGetApiPermissions]);

  useEffect(() => {
    GetUserPermissionsMutate({
      userId: userId,
    });
  }, [updateGetUserPermissions]);

  useEffect(() => {
    GetRolesNotExistInUserRolesMutate({
      id: userId,
    });
  }, [updateGetUserOfficeRoles, updateGetUserOfficePostById]);

  useEffect(() => {
    GetUserOfficePostsMutate({
      id: userId,
    });
  }, [updateGetUserOfficePosts]);

  useEffect(() => {
    GetOfficePostsByUserIdMutate({
      id: userId,
    });
    GetUserRolesMutate({
      id: userId,
    });
  }, [updateGetUserOfficePostById]);

  const tabs = [
    {
      id: 0,
      key: "posts",
      title: " پست های سازمانی",
      icon: <Groups3Icon sx={{ marginBottom: "0 !important" }} />,
      child: !isLoading ? (
        <Posts
          userOfficePostsList={userOfficePosts}
          setUserOfficePosts={setUserOfficePosts}
          setUpdateGetUserOfficePosts={setUpdateGetUserOfficePosts}
          treeData={treeData}
          setTreeData={setTreeData}
          setUpdateGetUserOfficePostById={setUpdateGetUserOfficePostById}
        />
      ) : (
        <TabsSkeleton />
      ),
    },
    {
      id: 1,
      key: "roles",
      title: "نقش های سازمانی",
      icon: <ManageAccountsIcon sx={{ marginBottom: "0 !important" }} />,
      child: (
        <Roles
          userOfficeRoles={userOfficeRoles}
          setUpdateGetUserOfficeRoles={setUpdateGetUserOfficeRoles}
          userRoleOptions={userRoleOptions}
          setUserOfficeRoles={setUserOfficeRoles}
        />
      ),
    },
    {
      id: 2,
      key: "certificate",
      title: "مجوز های اختصاصی",
      icon: (
        <WorkspacePremiumOutlinedIcon sx={{ marginBottom: "0 !important" }} />
      ),
      child: (
        <Certificate
          userPermissionsList={userPermissionsList}
          userPermissionOptions={userPermissionOptions}
          setUpdateGetUserPermissions={setUpdateGetUserPermissions}
          setUserPermissionsList={setUserPermissionsList}
          setUpdateGetApiPermissions={setUpdateGetApiPermissions}
        />
      ),
    },
    {
      id: 3,
      key: "reports",
      title: "گزارشات",
      icon: <ListAltOutlinedIcon sx={{ marginBottom: "0 !important" }} />,
      child: <Reports userReportList={userReportList!} />,
    },
    {
      id: 4,
      key: "menus",
      title: "منوها",
      icon: <MenuOutlinedIcon sx={{ marginBottom: "0 !important" }} />,
      child: <Menus userMenus={userMenus} setUserMenus={setUserMenus} />,
    },
    {
      id: 5,
      key: "password",
      title: "تغییر رمز عبور",
      icon: <HttpsOutlinedIcon sx={{ marginBottom: "0 !important" }} />,
      child: <ChangePassword />,
    },
  ];
  let findedActiveTabs = [] as any;

  tabs?.map((item: any) => {
    findedActiveTabs.push(item);
  });

  return (
    <>
      <span className="permissions-tabsPanel">
        <TabPanelCmp tab={findedActiveTabs} colorTab={"#01af43"} />
      </span>
    </>
  );
};

export default PermissionsTabs;
